import React, { useState } from "react";
import { Box, Grid, Paper, Button, Alert } from "@mui/material";
import wlogo from "../../../assets/wlogo.png";
import logo from "../../../assets/logo.png";
import { styled } from "@mui/material/styles";
import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
import { useNavigate, useLocation } from 'react-router';
import InputAdornment from '@mui/material/InputAdornment';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import "../../../assets/Css/Login.css";
import { axiosFetch } from '../../../utils/AxiosFetch';
import { Link } from 'react-router-dom'
import { SnackbarActions } from '../../../redux/actions/snackbar.actions';
import { useDispatch } from 'react-redux';


const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary.anchor,
  // backgroundColor: "#f1f8e9",
  height: "100vh",
}));

export default function ResetPassword() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const search = useLocation().search;
  const key = new URLSearchParams(search).get('key');
  console.log(key);
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [pwdResetStatus, setPwdResetStatus] = useState(0);
  const [showPwd, setShowPwd] = useState(false);
  const [showConfirmPwd, setShowConfirmPwd] = useState(false);
  const [isError, setisError] = useState(0);
  const [isExpired, setIsExpired] = useState(false);
  const [errMsg, setErrMsg] = useState("")

  const handleResetPwd = () => {
    if (isError === 0) {
      axiosFetch({
        method: "post",
        url: "/account/resetpassword",
        requestConfig: {
          "Token": !key ? null : key.replace(/ /g, '+'),
          "Password": password
        }
      })
        .then((res) => {
          if (res.status === 200) {
            setPwdResetStatus(res.data);
          }
          if (res.status === 400) {
            if(res.data === "Invalid Token"){
              setIsExpired(true)
              setErrMsg("Your reset password link has been expired");
            }
            // dispatch(SnackbarActions(true, "error", "Something Went Wrong!"))
          }
        })
        .catch((err) => {
          console.error(err);
        })
    }
  };

  const navigateHome = () => {
    navigate("/");
  };

  ValidatorForm.addValidationRule("isPasswordMatch", (value) => {
    if (value !== password) {
      return false;
    }
    return true;
  });
  ValidatorForm.addValidationRule("haveLength", (value) => {
    if (value.length < 6) {
      return false;
    }
    return true;
  });
  ValidatorForm.addValidationRule("valid", (value) => {
    var paswd = /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{7,15}$/;
    if (value.match(paswd)) {
      return true;
    }
    return false;
  });

  return (
    <div className="argus-login-main">
      <Box sx={{ width: "100%" }}>
        <Grid
          container
          alignItems="center"
          justifyContent="center"
          style={{
            width: "100%",
            backgroundColor: "transparent",
          }}
        >
          <Grid item xs={6}>
            <Item
              className="argus-logo-container"
              style={{
                width: "100%",
                backgroundColor: "transparent",
              }}
            >
              <div className="banner">
                <div className="logo-ai">
                  <img src={wlogo} alt="Ai Logo" className="brand-logo" />
                </div>
              </div>
            </Item>
          </Grid>
          <Grid item xs={6} alignItems="center" justifyContent="center">
            <Item
              className="login-container"
              style={{
                width: "100%",
                backgroundColor: "transparent",
              }}
            >
              <div className="login-main">
                <img src={logo} alt="Ai Logo" className="logo" />
                {pwdResetStatus === "Success" ? "" : <><h2 className='login-heading'>Reset Password</h2><p>Please create a new strong password to login</p></>}
                <Box>
                  {pwdResetStatus === 0 ? (
                    <ValidatorForm
                      // ref="form"
                      data-testid="form"
                      onError={(errors) => {
                        console.log(errors.length);
                        setisError(errors.length);
                      }}
                      onSubmit={() => handleResetPwd()}
                    >
                      {isExpired ? <Alert severity="error">{errMsg}.</Alert> : ""}
                      <TextValidator
                        variant="outlined"
                        className="signin-input-container"
                        label="New Password"
                        onChange={(e) => {
                          setIsExpired(false)
                          setPassword(e.target.value)}}
                        name="password"
                        type={showPwd ? "text" : "password"}
                        value={password}
                        validators={["required", "haveLength", "valid"]}
                        errorMessages={["Please fill out this field", "Password must have atleast 6 Characters", "Password must have atleast one special char,one non-numeric and numeric value"]}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment className="eye-icon">
                              {showPwd ? (
                                <VisibilityOffIcon
                                  onClick={() => setShowPwd(false)}
                                />
                              ) : (
                                <VisibilityIcon
                                  onClick={() => setShowPwd(true)}
                                />
                              )}
                            </InputAdornment>
                          ),
                        }}
                      />
                      <TextValidator
                        variant="outlined"
                        className="signin-input-container"
                        label="Confirm Password"
                        onChange={(e) => {
                          setIsExpired(false)                          
                          setConfirmPassword(e.target.value)}}
                        name="password"
                        type={showConfirmPwd ? "text" : "password"}
                        value={confirmPassword}
                        validators={["required", "isPasswordMatch"]}
                        errorMessages={[
                          "Please fill out this field",
                          "Password and Confirm Password should be same",
                        ]}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment className="eye-icon">
                              {showConfirmPwd ? (
                                <VisibilityOffIcon
                                  onClick={() => setShowConfirmPwd(false)}
                                />
                              ) : (
                                <VisibilityIcon
                                  onClick={() => setShowConfirmPwd(true)}
                                />
                              )}
                            </InputAdornment>
                          ),
                        }}
                      />
                      <Link
                        data-testid="btn-forget"
                        to="/"
                        style={{ float: "right" }}
                        className="btn-forget"
                        component="button"
                      >
                        Back to Login
                      </Link>
                      <Button
                        loading={true}
                        data-testid="btn-login"
                        className="login-btn"
                        // onClick={() => handleResetPwd()}
                        type="submit"
                      >
                        Reset Password
                      </Button>
                    </ValidatorForm>
                  ) : (
                    <>
                      <h2>Your password has been updated successfully!</h2>
                      <section>
                        Now you can login with your new password.
                      </section>
                      <Button
                        loading={true}
                        data-testid="btn-login"
                        className="login-btn"
                        onClick={() => navigateHome()}
                        type="submit"
                      >
                        OK
                      </Button>
                    </>
                  )}
                </Box>
              </div>
            </Item>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
}
